/** Whether a flush the desk requested is one this device hasn't acted on.
 *
 * The server keeps the timestamp until the desk issues a fresh one, so a
 * device sees the same request on every beat for as long as it stands.
 * Acting on each of those would reset the backoff on every failing page
 * every 20 seconds — a retry storm dressed up as a feature — so the device
 * remembers the last one it handled.
 *
 * Compares instants, not strings: both sides are RFC 3339 but their
 * fractional seconds are not, and `"...:00.5Z" < "...:00Z"` lexically,
 * which would let a newer request read as older. */
export function shouldHandleFlush(
  requestedAt: string | null,
  handledAt: string | null,
): boolean {
  if (!requestedAt) return false;
  const requested = Date.parse(requestedAt);
  if (Number.isNaN(requested)) return false;
  if (!handledAt) return true;
  const handled = Date.parse(handledAt);
  return Number.isNaN(handled) || requested > handled;
}
